/**
 * Session persistence.
 *
 * Deliberately small and deliberately in localStorage for now: the spike proved
 * the OIDC flow, not the storage strategy. Persistent crypto storage (IndexedDB)
 * is a separate, unverified piece of work — see docs/spike-2026-09-09.md.
 *
 * КЛЮЧ ЗАВИСИТ ОТ СЕРВЕРА (2026-09-13): сессии прода и стенда живут рядом и не
 * затирают друг друга, поэтому переключение туда-обратно не требует логина заново.
 */
import { serverStoragePrefix } from "../config";
export interface StoredSession {
  accessToken: string;
  refreshToken?: string;
  deviceId: string;
  clientId: string;
  /**
   * Момент истечения access-токена MAS (epoch ms). MAS выдаёт токены на
   * 300 секунд (замерено по логам, 14.09). Поле появилось 2026-09-14 для
   * починки 401 при входе в звонок: до него клиент НЕ ЗНАЛ, когда токен
   * протухнет, и упирался в 401 на getOpenIdToken спустя 5+ минут после
   * логина. Опционально, потому что старые сохранённые сессии его не
   * имеют — для них действует запасной путь «один retry по 401».
   */
  accessTokenExpiresAt?: number;
}

/** Вычисляется при каждом вызове: сервер мог смениться без перезагрузки страницы. */
function sessionKey(): string {
  return `${serverStoragePrefix()}.session`;
}

export function loadSession(): StoredSession | null {
  const key = sessionKey();
  const raw = localStorage.getItem(key);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as StoredSession;
  } catch {
    localStorage.removeItem(key);
    return null;
  }
}

export function saveSession(s: StoredSession): void {
  localStorage.setItem(sessionKey(), JSON.stringify(s));
}

export function clearSession(): void {
  localStorage.removeItem(sessionKey());
}
